function ProfileBox({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '36'} height=${dimensions || '36'} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 4V32H4V4H32ZM32 0H4C1.78 0 0 1.8 0 4V32C0 34.2 1.78 36 4 36H32C34.2 36 36 34.2 36 32V4C36 1.8 34.2 0 32 0ZM18 18C14.7 18 12 15.3 12 12C12 8.7 14.7 6 18 6C21.3 6 24 8.7 24 12C24 15.3 21.3 18 18 18ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM30 30H6V26.94C6 21.94 13.94 19.78 18 19.78C22.06 19.78 30 21.94 30 26.94V30ZM10.62 26H25.38C24 24.88 20.62 23.76 18 23.76C15.38 23.76 11.98 24.88 10.62 26Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default ProfileBox;
